<script setup lang="ts">
import { Carousel, Slide } from "vue3-carousel";
import { ref } from "vue";
import { images } from "~/utilities/images";

const reviewCarousel = ref(null);

const reviews = ref([
  {
    rate: 5,
    text: `“Ni är bäst! 🙂”`,
    name: `Peter Gutniak`,
    company: `Vaccinationsgruppen AB`,
    img: images.bild1
  },
  {
    rate: 5,
    text: `“Känns fantastiskt att vara tillbaka som kund hos er och äntligen få möjlighet att konsumera riktigt ond, klimatförstörande, elak, extremhöger, dödsknarkarnazist-el”`,
    name: `Max Å.`,
    company: `Stockholm`,
    img: images.bild2
  },
  {
    rate: 5,
    text: `“Vilket härligt elbolag ni är”`,
    name: `Mattias Gunnarsson`,
    company: `Göteborg`,
    img: images.bild3
  },
]);

const carouselConfig = {
  settings: {
    itemsToShow: 1.2,
    snapAlign: "center",
  },
  breakpoints: {
    280: {
      itemsToShow: 1.2,
      snapAlign: "center",
    },
    700: {
      itemsToShow: 2.2,
      snapAlign: "start",
    },
    900: {
      itemsToShow: 3.2,
      snapAlign: "start",
    },
  },
};
</script>

<template>
  <section class="bg-gray pt-60 pb-80">
    <div class="container">
      <div class="mb-40 text-center lg:max-w-[50rem] mx-auto">
        <h1 class="text-dark-blue">
          Några kunder som har valt att ge oss betyg
        </h1>
      </div>

      <div class="relative">
        <carousel v-bind="carouselConfig"
                  :breakpoints="carouselConfig.breakpoints"
                  ref="reviewCarousel"
                  class="m-auto overflow-hidden">
          <slide v-for="(r, i) in reviews" :key="i" class="pr-40 !block">
            <div class="text-left">
              <div class="mb-16">
                <NuxtImg loading="lazy" :src="r.img" class="max-w-140"/>
              </div>
              <div class="rate flex border-b pb-20">
                <svgo-rate-lightning-cyan-fill width="30" class="mx-4"/>
                <svgo-rate-lightning-cyan-fill width="30" class="mx-4"/>
                <svgo-rate-lightning-cyan-fill width="30" class="mx-4"/>
                <svgo-rate-lightning-cyan-fill width="30" class="mx-4"/>
                <svgo-rate-lightning-cyan-fill width="30" class="mx-4"/>
              </div>
              <div class="text font-semibold text-dark-blue text-20 text-18 mb-8 mt-12 leading-normal">{{ r.text }}</div>
              <div class="reviewer text-dark-blue text-20">
                <div class="font-semibold">{{ r.name }}</div>
                <div>{{ r.company }}</div>
              </div>
            </div>
          </slide>
        </carousel>

        <!-- Navigation Buttons -->
        <div class="flex justify-end mt-40">
          <div class="flex justify-center" v-if="reviewCarousel">
            <svgo-arr-l @click="reviewCarousel.prev()" width="40" class="mx-8 cursor-pointer"/>
            <svgo-arr-r @click="reviewCarousel.next()" width="40" class="mx-8 cursor-pointer"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
.carousel__track {
  align-items: baseline;
}
</style>
